import { Avatar, AvatarImage } from '@optools/components/ui/avatar';
import {
  PipelineConfigInfo,
  Team,
} from '@optools/services/operator-gateway/types/generated/graphql';

export interface TeamSpotProps {
  id?: PipelineConfigInfo['teamId'];
  showAbbreviation?: boolean;
  size?: number;
  team?: Pick<Team, 'abbreviation' | 'id'> | null;
}

export function TeamSpot({ id, showAbbreviation = true, size = 24, team }: TeamSpotProps) {
  const teamId = team?.id ?? id;
  return (
    <figure
      className="justify-content-left flex items-center gap-x-1"
      data-testid={`${teamId}-team-spot`}>
      <Avatar style={{ height: size, width: size }}>
        <AvatarImage
          src={`https://midfield.mlbstatic.com/v1/team/${
            teamId ? Math.abs(teamId) : '000'
          }/spots/${size + size / 2}`}
        />
      </Avatar>
      {showAbbreviation ? (
        <figcaption className="font-bold whitespace-nowrap">
          {team?.abbreviation?.toUpperCase() || 'NA'}
        </figcaption>
      ) : null}
    </figure>
  );
}
